import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

function Accessibility() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="info-page" id="main-content">
      <div className="info-shell info-shell--narrow">
        <nav className="info-breadcrumb" aria-label="Breadcrumb"><Link to="/" onClick={toTop}>Home</Link><span aria-hidden="true">/</span><span aria-current="page">Accessibility</span></nav>
        <header className="info-page__header info-page__hero">
          <p className="info-page__eyebrow">Access for everyone</p><h1>Accessibility statement.</h1>
          <p className="info-page__lead">We want the {siteConfig.brandName} storefront to be usable with different devices, input methods and assistive technologies.</p>
          <p className="info-page__updated">Last updated · September 2026</p>
        </header>
        <article className="info-page__article">
          <section><p className="info-page__eyebrow">01</p><h2>Our approach</h2><p>We work toward clear page structure, keyboard access, visible focus, useful image descriptions, readable contrast and reduced-motion preferences. Accessibility is an ongoing part of maintenance rather than a one-time claim.</p></section>
          <section><p className="info-page__eyebrow">02</p><h2>Known limitations</h2><p>Some differences between browsers, payment services or assistive technologies may affect the experience. We review reported barriers and prioritise fixes based on their impact.</p></section>
          <section><p className="info-page__eyebrow">03</p><h2>Feedback and assistance</h2><p>If a page or checkout step is difficult to use, tell us which page, device and browser were involved. We will offer reasonable assistance and use the report to improve the storefront.</p></section>
        </article>
        <aside className="info-page__contact-card"><p className="info-page__eyebrow">Accessibility contact</p><h2>Tell us about a barrier.</h2><p>Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.</p></aside>
      </div>
    </main>
  );
}

export default Accessibility;
